<script setup>
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
  modelValue: File,
  previewUrl: String,
})

const emit = defineEmits(['update:modelValue'])

const fileInput = ref(null)

function triggerPicker() {
  fileInput.value?.click()
}

function handleFile(e) {
  emit('update:modelValue', e.target.files[0])
}

const preview = computed(() => {
  // If user already has an image show it
  if (props.previewUrl && !(props.modelValue instanceof File)) {
    return props.previewUrl
  }

  // If user selected a file, show local file preview
  if (props.modelValue instanceof File) {
    return URL.createObjectURL(props.modelValue)
  }

  return null
})

const fileName = computed(() => {
  if (props.modelValue instanceof File) return props.modelValue.name
  return null
})
</script>

<template>
  <div class="flex items-center gap-4">
    <div
      class="flex h-20 w-20 cursor-pointer items-center justify-center overflow-hidden rounded-full bg-gray-100 shadow"
      @click="triggerPicker">
      <img v-if="preview" :src="preview" class="h-full w-full rounded-full object-cover" />

      <i v-else class="pi pi-user text-2xl text-gray-400" />
    </div>

    <div class="flex flex-col">
      <Button
        :label="t('actions.select_file')"
        icon="pi pi-file"
        severity="secondary"
        class="mb-1 w-full"
        @click="triggerPicker" />

      <span v-if="fileName" class="max-w-[180px] truncate text-xs text-gray-600">
        {{ fileName }}
      </span>

      <!-- Hidden native input -->
      <input ref="fileInput" type="file" accept="image/*" class="hidden" @change="handleFile" />
    </div>
  </div>
</template>

<i18n>
{
  "en": {
    "actions": {
      "select_file": "Select File"
    }
  },
  "de": {
    "actions": {
      "select_file": "Datei auswählen"
    }
  }
}
</i18n>
